module.exports = __webpack_public_path__ + "static/media/loading.b25c8aa1.gif";